export default __webpack_public_path__ + "static/media/cloud.69dcd102.svg";